import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import Tickets from "./Tickets";
import Requests from "./Requests";
import { useNavigate } from "react-router-dom";

const PastRequests = () => {
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState("PastRequest");

    const tabs = [
        { key: "PastRequest", label: "Past Requests" },
        { key: "Tickets", label: "Tickets" },
    ];

    const renderComponent = () => {
        if (activeTab === "PastRequest") return <Requests />
        if (activeTab === "Tickets") return <Tickets />;
        return null;
    };

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto flex flex-col">

            {/* Header */}
            <div className="sticky top-0 bg-white px-4 py-4 flex items-center space-x-3 shadow-sm border-b">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>History</h2>
            </div>

            {/* Modern Tabs */}
            <div className="sticky top-[64px] z-20 bg-gray-50 px-4 py-3">
                <div className="bg-white rounded-full shadow-md p-1 flex">

                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.key;

                        return (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className={`
                                    flex-1 text-center py-2.5 text-sm font-semibold rounded-full transition-all 
                                    ${isActive
                                        ? "text-white bg-gradient-to-r from-orange-400 to-red-500 shadow"
                                        : "text-gray-600"}
                                `}
                            >
                                {tab.label}
                            </button>
                        );
                    })}

                </div>
            </div>

            {/* Content */}
            <div className="p-4 pb-24">{renderComponent()}</div>
        </div>
    );
};

export default PastRequests;
